import { addSeconds } from 'date-fns'
import { useEffect, useMemo, useState } from 'react'

/**
 * Returns a new date based on interval thus ensuring that the dependent component
 * only re-renders at most based on the interval
 *
 * @param delaySeconds The date is adjusted by this amount of seconds
 * @param intervalSeconds The interval in seconds before the next date is returned
 */
export const useTimedDate = (
  delaySeconds: number = 0,
  intervalSeconds: number = 60,
) => {
  const [date, setDate] = useState(addSeconds(new Date(), delaySeconds))

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDate(addSeconds(new Date(), delaySeconds))
    }, intervalSeconds * 1000) // 60000ms = 1 minute

    return () => clearInterval(intervalId)
  }, [delaySeconds, intervalSeconds])

  return useMemo(() => date, [date])
}
